import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

const IconLight = ({ icon }) => {
  return <FontAwesomeIcon icon={["fal", icon]} />;
};

IconLight.propTypes = {
  icon: PropTypes.string.isRequired
};

export default IconLight;



// WEBPACK FOOTER //
// ./src/components/icon_light/IconLight.jsx